<template>
  <div class="contrat-pdf">
    <div v-if="loading">
      <div>Chargement du document en cours</div>
      <BaseLoader />
    </div>
    <BaseMessage
      v-else-if="serverError"
      type="error"
    >
      {{ serverError }}
    </BaseMessage>
    <div
      v-else
      class="pdf-container"
    >
      <embed
        :src="urlDocumentPdf"
        width="100%"
        height="100%"
        type="application/pdf"
      >
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { createUrl, downloadFile } from '@/utils/axios-helper'
import BaseLoader from '@/components/common/base-loader.vue'
import BaseMessage from '@/components/common/base-message.vue'

export default {
  name: 'DocumentPdf',
  components: { BaseLoader, BaseMessage },
  props: {
    numeroContrat: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: true,
      serverError: null,
      urlDocumentPdf: null
    }
  },

  created () {
    this.getDocumentPdf(this.numeroContrat)
      .then(response => {
        if (this.$vuetify.breakpoint.smAndDown) {
          this.getDocumentFileName(this.numeroContrat)
            .then((filename) => {
              downloadFile(response, filename)
            })
        } else {
          this.urlDocumentPdf = createUrl(response)
        }
      })
      .catch(error => {
        if (error.response.data) {
          if (error.response.status === 404) {
            this.serverError = 'Le document est introuvable actuellement. Veuillez réessayer ultérieurement'
          } else {
            this.serverError = error.response.data.message
          }
        } else {
          this.serverError = error
        }
      })
      .finally(() => this.loading = false)
  },
  methods: {
    ...mapActions({
      getDocumentPdf: 'contrat/getDocumentPdf',
      getDocumentFileName: 'contrat/getDocumentFileName'
    })
  }
}
</script>
<style lang="scss" scoped>
.contrat-pdf {
  position: relative;

  .pdf-container {
    width: 100%;
    height: calc(100vh - 100px);
  }
}
</style>
